import { Card, CardContent, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import CustomDatePicker from 'src/components/data-picker/CustomDatePicker';
import Label from 'src/components/Label';
import { snackActions } from 'src/components/notistack/SnackbarUtilsConfigurator';
import PermissionButton from 'src/components/permission/PermissionButton';
import { PermissionPath } from 'src/components/permission/PermissionPath';
import { transactionsTaxReport } from 'src/services/transactionServices';
import { convertDateToServerFormat } from 'src/utils/formatTime';

const INITIAL_VALUES = {
  start_date: convertDateToServerFormat(new Date(new Date())),
  end_date: convertDateToServerFormat(new Date(new Date())),
};

const TaxOfficeReportManagement = () => {
  const [filterValue, setFilterValue] = useState(INITIAL_VALUES);
  const [excelLoading, setExcelLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setExcelLoading(true);

      const response = await transactionsTaxReport(filterValue);
      const blob = new Blob([response.data]);
      const downloadLink = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadLink;
      a.download = `گزارش اداره مالیات.xlsx`;
      a.click();
      snackActions.success('فایل درخواستی دانلود شد');
    } catch (error) {
      console.error('فایل دانلود نشد', error);
    } finally {
      setExcelLoading(false);
    }
  };

  return (
    <>
      <Grid item xs={12} sm={4} md={8}>
        <Card sx={{ width: '1200', position: 'relative', marginBottom: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <CardContent>
                <Typography variant="h5" component="div">
                  <CustomDatePicker
                    label="از تاریخ"
                    value={filterValue.start_date || ''}
                    onChange={(value) => {
                      setFilterValue((prev) => ({
                        ...prev,
                        start_date: convertDateToServerFormat(value),
                      }));
                    }}
                  />
                </Typography>
              </CardContent>
            </Grid>
            <Grid item xs={12} sm={4}>
              <CardContent>
                <Typography variant="h5" component="div">
                  <CustomDatePicker
                    label="تا تاریخ"
                    value={filterValue.end_date || ''}
                    onChange={(value) => {
                      setFilterValue((prev) => ({
                        ...prev,
                        end_date: convertDateToServerFormat(value),
                      }));
                    }}
                  />
                </Typography>
              </CardContent>
            </Grid>
            <Grid item xs={12} sm={4}>
              <CardContent>
                <Typography variant="h5" component="div">
                  <PermissionButton
                    title={'خروجی اکسل'}
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={() => handleDownload()}
                    loading={excelLoading}
                    permission={PermissionPath.transaction.taxReport}
                  />
                </Typography>
              </CardContent>
            </Grid>
          </Grid>
        </Card>
      </Grid>

<Grid item xs={12} sm={4} md={8}>
  <Card sx={{ width: '1200', position: 'relative', marginBottom: 2 }}>
    <CardContent>
      <Typography variant="h5" component="div">
        <Label color="success">1</Label> ستون نام واحد: نام واحد
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">2</Label> ستون مبلغ دریافتی از مشتری: کل دریافتی‌ها{' '}
        <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> به‌غیر از نقدی
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">3</Label> ستون مبلغ سفارشات کنسلی: مجموع مبالغ سفارشات کنسل‌شده{' '}
        <span style={{ color: 'red' }}>(کل سفارش یا بخشی از سفارش)</span>
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">4</Label> ستون بدهی به واحد: مجموع دریافتی‌های سفارشات فقط آنلاین منهای سود آن‌ها منهای سود سفارشات نقدی
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">5</Label> ستون درآمد ناخالص: سود کل سفارشات کنسل‌نشده
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">6</Label> ستون درآمد خالص: ستون درآمد ناخالص منهای ستون ارزش افزوده
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">7</Label> ستون ارزش افزوده: <span style={{ color: 'red' }}>9 درصد</span> ستون درآمد ناخالص تا دو رقم اعشار
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">8</Label> ستون درگاه ملت: کل دریافتی‌ها <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> از درگاه ملت
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">9</Label> ستون درگاه پارسیان: کل دریافتی‌ها <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> از درگاه پارسیان
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">10</Label> ستون درگاه سپهر: کل دریافتی‌ها <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> از درگاه سپهر
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">11</Label> ستون درگاه زرین پال ملت: کل دریافتی‌ها <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> از درگاه زرین پال ملت
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">12</Label> ستون درگاه زرین پال پاسارگاد: کل دریافتی‌ها <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> از درگاه زرین پال پاسارگاد
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">13</Label> ستون درگاه کیف پول: کل دریافتی‌ها <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> از درگاه کیف پول
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">14</Label> ستون درگاه خرید نقدی: کل دریافتی‌ها <span style={{ color: 'red' }}>(حتی کنسل‌شده‌ها)</span> به‌صورت نقدی
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="success">15</Label> ستون تخفیف: جمع تخفیف‌های داده‌شده به مشتری برای سفارشات کنسل‌نشده
      </Typography>
      <Typography variant="h5" component="div">
        <Label color="warning">*</Label> نکته: در صورتی‌که کاربر کد تخفیف داشته باشد، روی ستون‌های مبلغ دریافتی از مشتری، درگاه ملت، درگاه پارسیان، درگاه زرین پال ملت، درگاه زرین پال پاسارگاد، درگاه کیف پول، درگاه خرید نقدی اعمال می‌شود و پس از کسر تخفیف مبلغ دریافت می‌شود.
      </Typography>
    </CardContent>
  </Card>
</Grid>


    </>
  );
};

export default TaxOfficeReportManagement;
